<template>
  <!-- 云端运行日志 -->
  <div>
    <div>
      <div class="mb10">
        <!-- <v-input
              class=""
              v-model="searchValue"
              placeholder="请输入搜索内容"
              suffix-icon="v-icon-search"
              @change="getData"
        ></v-input> -->
      </div>
      <div>
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
        >
        <vxe-table-column
            field="level"
            show-overflow
            min-width="120"
            title="日志等级"
          ></vxe-table-column>
        <vxe-table-column
            field="product_key"
            show-overflow
            min-width="120"
            title="产品Key"
          ></vxe-table-column>
          <vxe-table-column
            field="device_key"
            show-overflow
            min-width="120"
            title="设备Key"
          ></vxe-table-column>
          <vxe-table-column
            field="result"
            show-overflow
            min-width="80"
            title="上报结果"
          ></vxe-table-column>
          <vxe-table-column
            field="message"
            show-overflow
            min-width="220"
            title="信息"
          ></vxe-table-column>
          <vxe-table-column
            field="record_time"
            show-overflow
            min-width="120"
            title="时间"
          ></vxe-table-column>

          <vxe-table-column
            field="file_name"
            show-overflow
            min-width="120"
            title="文件名称"
          ></vxe-table-column>
          <!-- <vxe-column title="操作" min-width="140">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn1"
                  slot="reference"
                  @click="showDownModel(slotProps.row)"
                  >下载</v-button
                ></span
              >
            </template>
          </vxe-column> -->
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="page-basic"
        is-show-total
        is-change-size
        is-input-page
        :current-page="this.currentPage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>

export default {
  components: {  },
  props:{
    deviceKey:{}
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      table: [],
      Id: "",
      searchValue:'',
      url:''
    };
  },
  created() {
    this.getData();
  },
  watch:{
    deviceKey(newdata){
      this.deviceKey = newdata
    },
  },
  methods: {
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        device_key: this.deviceKey,
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/log/dev/local/get/reply/v1",
        subData
      );
      if (res.code === 0) {
        this.table = res.data.list
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1
      this.getData();
    },
  },
  beforeDestroy() {},
};
</script>
  <style lang="scss">
.low-title {
  font-size: 18px;
}
</style>
